/* eslint-disable no-mixed-spaces-and-tabs */
import { toCamelCase } from '@/utils/constants';
import { getContrastingColor } from '@uiw/react-color';
import axios from 'axios';
// import juice from 'juice';
import { v4 as uuidv4 } from 'uuid';

export const EMAIL_TEMPLATE_TYPES = {
	preRenewal: 'Renewal',
	scopeOfAdvice: 'New Business',
	statementOfAdvice: 'Quote',
	other: 'Other',
};

export const EMAIL_TEMPLATE_TYPE_KEYS = Object.keys(EMAIL_TEMPLATE_TYPES).reduce(
	(acc, key) => ({
		...acc,
		[key]: key,
	}),
	{},
);

export const EMPTY_HTML =
	'<p><span style="font-family: Arial, sans-serif; font-size: 14px;"></span><p>';

export const USER = 'user';
export const BROKERAGE = 'brokerage';
export const MS_GRAPH = 'msGraph';
export const DEAL = 'deal';
export const CLAIM = 'claim';
export const INSIGHT_CLAIM = 'insightClaim';
export const CLIENT = 'client';
export const CLIENT_INSIGHT = 'insight';

export const FIELDS = [
	// User
	{ label: 'Name', type: USER, value: 'name', node: 'span' },
	{ label: 'Phone number', type: USER, value: 'phoneNumber', node: 'span' },
	{ label: 'Email', type: MS_GRAPH, value: 'username', node: 'a' },
	{ label: 'About', type: USER, value: 'aboutUser', node: 'p' },
	{ label: 'Avatar', type: USER, value: 'imageUrl', node: 'img' },
	{ label: 'Disclosure URL', type: USER, value: 'disclosureUrl', node: 'a' },
	{ label: 'LinkedIn', type: USER, value: 'linkedIn', node: 'a' },
	{ label: 'FSP number', type: USER, value: 'fspNumber', node: 'span' },
	{ label: 'Signature', type: USER, value: 'signature', node: 'div' },

	// Brokerage
	{ label: 'Brokerage name', type: BROKERAGE, value: 'name', node: 'span' },
	{ label: 'Address', type: BROKERAGE, value: 'address', node: 'p' },
	{ label: 'Phone number', type: BROKERAGE, value: 'phoneNumber', node: 'span' },
	{ label: 'Logo', type: BROKERAGE, value: 'fullLogo', node: 'img' },
	{ label: 'Brokerage FSP Number', type: BROKERAGE, value: 'fspNumber', node: 'span' },
	{ label: 'Public Disclosure URL', type: BROKERAGE, value: 'disclosureUrl', node: 'a' },
	{ label: 'Contact Email', type: BROKERAGE, value: 'contactEmail', node: 'a' },
	{ label: 'Privacy Statement', type: BROKERAGE, value: 'privacyStatement', node: 'a' },
	{ label: 'Terms of Engagement', type: BROKERAGE, value: 'termsOfEngagement', node: 'a' },
	{ label: 'Website', type: BROKERAGE, value: 'website', node: 'a' },

	// Clients
	{ label: 'Name', type: CLIENT, value: 'name', node: 'span' },
	{ label: 'First name', type: CLIENT, value: 'contactFirstName', node: 'span' },
	{ label: 'Last name', type: CLIENT, value: 'contactLastName', node: 'span' },
	{ label: 'Phone number', type: CLIENT, value: 'contactPhone', node: 'span' },
	{ label: 'Email', type: CLIENT, value: 'contactEmail', node: 'a' },
	{ label: 'Industry', type: CLIENT, value: 'industry', node: 'span' },
	{
		label: 'Number of employees',
		type: CLIENT,
		value: 'numberOfEmployees',
		node: 'span',
	},
	{ label: 'Annual revenue', type: CLIENT, value: 'annualRevenue', node: 'span' },
	{ label: 'Description', type: CLIENT, value: 'description', node: 'span' },

	// Deals
	{ label: 'Name', type: DEAL, value: 'dealName', node: 'span' },
	{ label: 'Client type', type: DEAL, value: 'clientType', node: 'span' },
	{ label: 'Goals of cover', type: DEAL, value: 'goalsOfCover', node: 'span' },
	{ label: 'Needs analysis', type: DEAL, value: 'needsAnalysis', node: 'ul' },
	{
		label: 'Needs analysis table',
		type: DEAL,
		value: 'needsAnalysisTable',
		node: 'div',
		reliesOn: 'needsAnalysis',
	},
	{ label: 'Risk classes', type: DEAL, value: 'riskClasses', node: 'span' },
	{ label: 'Description', type: DEAL, value: 'description', node: 'span' },
	{ label: 'Renewal date', type: DEAL, value: 'renewalDate', node: 'span' },

	// Claims
	{ label: 'Name', type: CLAIM, value: 'dealName', node: 'span' },
	{ label: 'Claim number', type: CLAIM, value: 'claimNumber', node: 'span' },
	{ label: 'Claim type', type: CLAIM, value: 'claimType', node: 'span' },
	{ label: 'Date of loss', type: CLAIM, value: 'dateOfLoss', node: 'span' },
	{ label: 'Insurer', type: CLAIM, value: 'insurer', node: 'span' },
	{ label: 'Description of loss', type: INSIGHT_CLAIM, value: 'Description', node: 'span' },
	{ label: 'Policy number', type: INSIGHT_CLAIM, value: 'PolicyNumber', node: 'span' },

	// Pre-set tables
	{
		label: 'Pre-renewal tables',
		block: true,
		type: DEAL,
		value: 'renewalTables',
		node: 'div',
		requirements: EMAIL_TEMPLATE_TYPE_KEYS.preRenewal,
	},

	{
		label: 'Scope table',
		block: true,
		type: DEAL,
		value: 'soaTable',
		node: 'div',
		requirements: EMAIL_TEMPLATE_TYPE_KEYS.scopeOfAdvice,
	},
	{
		label: 'SOA class of risk table',
		block: true,
		type: 'soa',
		value: 'classOfRiskTable',
		node: 'div',
		requirements: EMAIL_TEMPLATE_TYPE_KEYS.statementOfAdvice,
	},
	{
		label: 'SOA recommendation',
		block: true,
		type: 'soa',
		value: 'recommendation',
		node: 'div',
		requirements: EMAIL_TEMPLATE_TYPE_KEYS.statementOfAdvice,
	},
	{
		label: 'SOA payment info',
		block: true,
		type: 'soa',
		value: 'paymentInfo',
		node: 'div',
		requirements: EMAIL_TEMPLATE_TYPE_KEYS.statementOfAdvice,
	},
];

// export const EMAIL_TEMPLATE_TYPES = {
// 	preRenewal: 'Renewal',
// 	scopeOfAdvice: 'New Business',
// 	statementOfAdvice: 'Quote',
// 	other: 'Other',
// };
// export const TAGS = ['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'IMG', 'A'];

export const TAG_LABELS = {
	P: 'Paragraph',
	H1: 'Heading 1',
	H2: 'Heading 2',
	H3: 'Heading 3',
	H4: 'Heading 4',
	H5: 'Heading 5',
	H6: 'Heading 6',
	IMG: 'Image',
	// A: 'Link',
	TABLE: 'Table',
	UL: 'List',
	OL: 'List',
};

export const TAGS = Object.keys(TAG_LABELS);
const TABLE_TAGS = ['TR', 'TD', 'TH'];
const LINK_TAG = 'A';

export const BLOCK_ELEMENTS = [
	'p',
	'div',
	'table',
	'ul',
	'ol',
	'li',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
];

export const assignBlockIds = (html) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(
		// html.replace(/>\s+</g, '><').replace(/\n/g, ''),
		html.replace(/\n/g, '').replace('[object Object]', ''),
		'text/html',
	);

	const tagSelector = TAGS.concat([...TABLE_TAGS, LINK_TAG]).join(',');
	doc.body.querySelectorAll(tagSelector).forEach((el) => {
		const uniqueKey = uuidv4();
		if (!el.hasAttribute('data-id')) {
			el.setAttribute('data-id', uniqueKey);
		}
	});

	console.log('assignBlockIds', doc.documentElement.outerHTML);
	return doc.documentElement.outerHTML;
};

export const adjustHtmlTablePadding = (html, headContent) => {
	console.log('adjustHtmlTablePadding html', { html, headContent });

	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');

	if (!doc.body || doc.body.innerHTML.trim().length === 0) {
		doc.body.innerHTML = html;
	}

	const firstElement = Array.from(doc.body.childNodes).find(
		(n) => n.nodeType === Node.ELEMENT_NODE,
	);

	if (firstElement) {
		const styleObj = parseStyleString(firstElement.getAttribute('style') ?? '');

		const hasWidth = styleObj.width || styleObj.maxWidth || styleObj['max-width'];

		if (!hasWidth) {
			const wrapper = doc.createElement('div');
			wrapper.setAttribute('style', 'max-width:700px;');

			doc.body.replaceChild(wrapper, firstElement);
			wrapper.appendChild(firstElement);
		}
	}

	if (headContent && headContent.trim().length > 0) {
		const headDoc = parser.parseFromString(headContent, 'text/html');

		console.log('head content', headContent);
		Array.from(headDoc.head.childNodes).forEach((node) => {
			doc.head.appendChild(doc.importNode(node, true));
		});
	}

	console.log('Head style', doc.head.style);
	const styleTag = doc.createElement('style');
	styleTag.textContent = `
		body {
			font-family: Arial, sans-serif;
			font-size: 14px;
			-webkit-text-size-adjust: 100%;
		}
	`;

	if (doc.head.firstChild) {
		doc.head.insertBefore(styleTag, doc.head.firstChild);
	} else {
		doc.head.appendChild(styleTag);
	}

	doc.querySelectorAll('td, th').forEach((cell) => {
		cell.querySelectorAll('p, strong').forEach((el) => {
			el.style.marginBlockStart = '0';
			el.style.marginBlockEnd = '0';
			el.style.padding = '0';
			el.style.margin = '0';
		});
	});

	doc.querySelectorAll('p').forEach((p) => {
		const elementChildren = Array.from(p.childNodes).filter(
			(n) => n.nodeType === Node.ELEMENT_NODE,
		);

		console.log('element children', elementChildren);
		const textChildren = Array.from(p.childNodes).filter(
			(n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim().length > 0,
		);

		if (
			elementChildren.length === 1 &&
			elementChildren[0].tagName === 'IMG' &&
			textChildren.length === 0
		) {
			const img = elementChildren[0];
			p.replaceWith(img);
		}
	});

	console.log('adjustHtmlTablePadding', doc.documentElement.outerHTML);
	return doc.documentElement.outerHTML;
};

export const convertToHandlebarsTemplate = (html) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');

	const existingMeta = doc.head.querySelector('meta[charset]');
	if (!existingMeta) {
		const meta = doc.createElement('meta');
		meta.setAttribute('charset', 'UTF-8');
		doc.head.prepend(meta);
	}

	const templateValues = [];

	doc.querySelectorAll('ul, ol').forEach((list) => {
		const liVariable = list.getAttribute('template-value');
		const listItems = Array.from(list.querySelectorAll('li[template-value]'));
		if (liVariable || listItems.length > 0) {
			const variable = liVariable ?? listItems[0].getAttribute('template-value');
			templateValues.push(variable);
			const placeholder = doc.createTextNode(`{{{${variable}}}}`);
			list.replaceWith(placeholder);
		}
	});

	const signatureElements = doc.querySelectorAll('[email-signature]');
	const signatureIdElements = doc.querySelectorAll('#email-signature');
	console.log('Signature elements', { signatureElements, signatureIdElements });

	const elements = doc.querySelectorAll('[template-value]');
	elements.forEach((el) => {
		if (el.tagName === 'LI') return;
		const variable = el.getAttribute('template-value');
		templateValues.push(variable);
		if (el.tagName === 'IMG') {
			el.setAttribute('src', `{{${variable}}}`);
		} else if (el.tagName === 'A') {
			el.setAttribute('href', `{{${variable}}}`);
			// } else if (el.tagName === 'TABLE') {
			// 	console.log('TABLE element', el);
			// 	Array.from(el.children).forEach(child => {
			// 		child.remove();
			// 	});
			// 	el.innerHTML =`{{${variable}}}`;
		} else {
			// console.log('Element', el);
			Array.from(el.children).forEach((child) => {
				child.remove();
			});
			el.innerHTML = `{{{${variable}}}}`;
		}
	});

	const doctype = '<!DOCTYPE html>';
	const handlebarsHtml = doc.documentElement.outerHTML;

	console.log('HandlebarsHtml', handlebarsHtml);

	const requirements = Array.from(
		new Set(templateValues.map((v) => v.split('.')?.[0]).filter(Boolean)),
	);

	return { template: `${doctype}\n${handlebarsHtml}`, requirements };
};

export const parseStyleString = (styleString = '') => {
	return (styleString ?? '').split(';').reduce((acc, rule) => {
		const [key, value] = rule.split(':');
		if (!key || !value) return acc;
		const camelCaseKey = key.trim().replace(/-([a-z])/g, (_, char) => char.toUpperCase());
		acc[camelCaseKey] = value.trim();
		return acc;
	}, {});
};

export const getNearestBackgroundColour = (node) => {
	let current = node.parentNode;
	const style = {};
	while (current && current.nodeType === Node.ELEMENT_NODE) {
		const styleAttr = current.getAttribute('style');

		if (styleAttr) {
			const styleObj = parseStyleString(styleAttr);
			// console.log('STYLE OBJ', styleObj);
			['backgroundColor', 'color', 'textAlign', 'fontFamily', 'fontSize'].forEach((key) => {
				if (styleObj[key] && !Object.keys(style).includes(key)) {
					style[key] = styleObj[key];
				}
			});
		}
		current = current.parentNode;
	}
	// console.log('STYLE OBJ', style, 'node', node);
	return style;
};

export const getParentHref = (node) => {
	const current = node.parentNode;
	if (current && current.nodeType === Node.ELEMENT_NODE) {
		return current.getAttribute('href');
	}
};

export const styleToString = (styleObj) => {
	return Object.entries(styleObj)
		.map(([key, value]) => {
			const kebabKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
			return `${kebabKey}: ${value}`;
		})
		.join('; ');
};

export const parseCssRules = (styleText) => {
	const rules = [];
	let depth = 0;
	let inMediaBlock = false;
	let currentSelector = '';
	let currentBlock = '';

	for (let i = 0; i < styleText.length; i++) {
		const char = styleText[i];

		// Detect start of media block
		if (styleText.startsWith('@media', i)) {
			inMediaBlock = true;
			depth = 0;
			continue;
		}

		// Track opening and closing braces
		if (char === '{') {
			depth++;
			if (!inMediaBlock && depth === 1) {
				currentSelector = currentBlock.trim();
				currentBlock = '';
			}
		} else if (char === '}') {
			depth--;
			if (inMediaBlock && depth === 0) {
				inMediaBlock = false; // End of media block
			} else if (!inMediaBlock && depth === 0) {
				// We're at end of a top-level rule
				const styles = currentBlock
					.split(';')
					.map((decl) => decl.trim())
					.filter(Boolean)
					.reduce((acc, decl) => {
						const [prop, val] = decl.split(':').map((s) => s.trim());
						if (prop && val) acc[toCamelCase(prop.replace('-', ' '))] = val;
						return acc;
					}, {});
				rules.push({ selector: currentSelector, styles });
				currentSelector = '';
				currentBlock = '';
			}
		} else {
			currentBlock += char;
		}
	}

	return rules;
};

export const normaliseEmailHtml = (html) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');

	doc.querySelectorAll('.show-on-mobile').forEach((el) => {
		el.remove();
	});

	doc.querySelectorAll('.hide-on-mobile').forEach((el) => {
		el.classList.remove('hide-on-mobile');
		if (!el.classList.length) {
			el.removeAttribute('class');
		}
	});

	const removeMsoComments = (node) => {
		if (
			node.nodeType === Node.COMMENT_NODE &&
			/\[if\s+!?mso\]|\[endif\]/i.test(node.nodeValue)
		) {
			node.remove();
			return;
		}

		Array.from(node.childNodes).forEach(removeMsoComments);
	};

	removeMsoComments(doc);
	return doc.documentElement.outerHTML;
};

export const removeWhitespaceFromHtml = (html) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');

	// Remove whitespace-only text nodes
	const walker = document.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, {
		acceptNode(node) {
			return node.nodeValue.trim() === ''
				? NodeFilter.FILTER_ACCEPT
				: NodeFilter.FILTER_REJECT;
		},
	});

	const nodesToRemove = [];
	while (walker.nextNode()) {
		nodesToRemove.push(walker.currentNode);
	}

	nodesToRemove.forEach((n) => n.parentNode.removeChild(n));

	return doc.body.innerHTML.trim();
};

const stripCssComments = (css = '') => css.replace(/\/\*[\s\S]*?\*\//g, '');

const mergeStyleBlocks = (doc) => {
	const styles = Array.from(doc.querySelectorAll('style'));

	if (styles.length <= 1) return;

	let mergedCss = '';

	styles.forEach((style) => {
		if (style.textContent) {
			mergedCss += '\n' + stripCssComments(style.textContent);
		}
	});

	// Keep the first <style>, remove the rest
	const primaryStyle = styles[0];
	primaryStyle.textContent = mergedCss.trim();

	styles.slice(1).forEach((style) => style.remove());
};

const removeIllegalStrongNodes = (doc) => {
	const headings = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

	headings.forEach((tag) => {
		doc.querySelectorAll(`strong > ${tag}`).forEach((heading) => {
			const strong = heading.parentNode;

			// Move <strong> inside heading
			strong.parentNode.replaceChild(heading, strong);
			heading.appendChild(strong);
		});
	});
};

const STRIP_ATTRS = [
	'backgroundcolor',
	'bordercolor',
	'borderstyle',
	'borderwidth',
	'bordertop',
	'borderbottom',
	'borderleft',
	'borderright',
	'padding',
	'basestyle',
	'htmlattributes',
];

const removeBuilderAttrs = (doc) => {
	doc.querySelectorAll('*').forEach((el) => {
		STRIP_ATTRS.forEach((attr) => {
			if (el.hasAttribute(attr)) {
				el.removeAttribute(attr);
			}
		});
	});
};

const removeIllegalNodeNesting = (doc) => {
	doc.querySelectorAll('strong, span, em, b, i').forEach((el) => {
		if (!el.textContent.trim() && el.children.length === 0) {
			el.remove();
		}
	});
	doc.querySelectorAll('em > div').forEach((div) => {
		const em = div.parentElement;
		em.replaceWith(div);
		div.querySelectorAll('p').forEach((p) => {
			p.style.fontStyle = 'italic';
		});
	});
};

export const parseHtmlAndConvertStyles = async (html) => {
	const parser = new DOMParser();
	let doc = parser.parseFromString(html, 'text/html');

	const preJuiceWalk = (node) => {
		if (node.nodeType === Node.ELEMENT_NODE && node?.tagName?.toUpperCase() !== 'BR') {
			if (node.tagName.toUpperCase() === 'DIV') {
				const childNodes = Array.from(node.childNodes);

				childNodes.forEach((child) => {
					console.log();
					if (child.nodeType === Node.TEXT_NODE && child.textContent.trim().length > 0) {
						const span = doc.createElement('p');
						span.appendChild(child.cloneNode());
						node.replaceChild(span, child);
					}
				});
			}
			if (node.tagName.toUpperCase() === 'STRONG') {
				const style = node.getAttribute('style');
				if (style && style.trim().length > 0) {
					const span = doc.createElement('span');
					span.setAttribute('style', style);
					node.removeAttribute('style');

					const parent = node.parentNode;
					parent.replaceChild(span, node);
					span.appendChild(node);
					node = span;
				}
			}
		}
		if (node.nodeType === Node.ELEMENT_NODE && node.tagName) {
			const style = node.getAttribute('style');
			const styleObj = parseStyleString(style);
			const newStyle = Object.entries(styleObj)
				.filter(([k]) => !k.startsWith('-'))
				.reduce(
					(acc, [k, v]) => ({
						...acc,
						[k]: v,
					}),
					{},
				);
			if (!style?.trim()) {
				node.removeAttribute('style');
			} else {
				node.setAttribute('style', styleToString(newStyle));
			}
		}

		Array.from(node.childNodes).forEach(preJuiceWalk);
	};

	// console.log('html before juice walk', doc.documentElement.outerHTML);
	preJuiceWalk(doc.body);
	mergeStyleBlocks(doc);
	removeIllegalStrongNodes(doc);
	removeIllegalNodeNesting(doc);
	removeBuilderAttrs(doc);

	// console.log('html after juice walk', doc.documentElement.outerHTML);

	const res = await axios
		.post(process.env.REACT_APP_CONVERT_HTML_STYLES, { html: doc.documentElement.outerHTML })
		.catch((e) => {
			console.error(`Error trying to inline email template styles`, e);
		});

	console.log('parseHtmlAndConvertStyles INLINE HTML', res);

	const inlinedHtml = res?.data ?? doc.documentElement.outerHTML; //juice(doc.documentElement.outerHTML, options);
	// const inlinedHtml = juice(doc.documentElement.outerHTML, {
	// 	preserveImportant: true,
	// 	insertPreservedExtraCss: true,
	// 	applyStyleTags: true,
	// 	applyWidthAttributes: true,
	// 	applyHeightAttributes: true,
	// 	preserveMediaQueries: true,
	// 	removeStyleTags: false,
	// });

	// console.log('parseHtmlAndConvertStyles INLINE HTML', inlinedHtml);
	doc = parser.parseFromString(inlinedHtml, 'text/html');

	const style = Array.from(doc.head.childNodes).find((n) => n.nodeName === 'STYLE');

	const parsedStyles = parseCssRules(style?.textContent ?? '');
	const headContent = doc?.head?.innerHTML ?? '';

	const walk = (node) => {
		if (node.nodeType === Node.ELEMENT_NODE && node?.tagName?.toUpperCase() !== 'BR') {
			const existingStyles = getClassAndInlineStyles(node, parsedStyles);
			const body = parsedStyles.find(({ selector }) => selector === 'body');
			const bodyStyle = ['color', 'textAlign', 'fontFamily'].reduce((acc, key) => {
				if (body?.styles[key]) {
					acc[key] = body?.styles[key];
				}
				return acc;
			}, {});

			if (['TH', 'TD'].includes(node.tagName.toUpperCase())) {
				const parent = node.parentNode;
				const parentStyle = parseStyleString(parent.getAttribute('style') ?? '');
				const colour = existingStyles.color ?? parentStyle.color;
				const bg =
					existingStyles.backgroundColor ??
					existingStyles.background ??
					parentStyle.backgroundColor ??
					parentStyle.background;
				existingStyles.backgroundColor = bg;

				const resolvedTextAlign =
					existingStyles.textAlign ??
					parentStyle.textAlign ??
					Array.from(node.querySelectorAll('p, span')).find((el) => {
						const s = parseStyleString(el.getAttribute('style') ?? '');
						return s.textAlign;
					})?.style?.textAlign;

				if (colour || !resolvedTextAlign) {
					try {
						const firstChild = node.children[0];
						const hasParagraphSpan =
							firstChild &&
							firstChild.tagName === 'P' &&
							firstChild.children.length === 1 &&
							firstChild.children[0].tagName === 'SPAN';

						const existingColour = hasParagraphSpan
							? parseStyleString(firstChild?.children[0].getAttribute('style') ?? '')
									.color
							: null;
						// node.children[0].children[0].tagName === 'SPAN' &&
						// parseStyleString(
						// 	node.children[0].children[0].getAttribute('style') ?? ''
						// ).color === colour;

						if (!hasParagraphSpan || !existingColour || !resolvedTextAlign) {
							const p = doc.createElement('p');
							const span = doc.createElement('span');
							if (colour) span.style.color = existingColour ?? colour;
							if (!resolvedTextAlign) span.style.textAlign = 'left';

							while (node.firstChild) {
								span.appendChild(node.firstChild);
							}

							p.appendChild(span);
							node.appendChild(p);
						}
					} catch (e) {
						console.error(
							'Error appending colour style to paragraph element in table',
							e,
						);
					}
				}
			}

			const nodeStyles = {
				...bodyStyle,
				...existingStyles,
			};

			node.setAttribute('style', styleToString(nodeStyles));
		}
		Array.from(node.childNodes).forEach(walk);
	};

	walk(doc.body);

	const finalHtml = normaliseEmailHtml(doc.documentElement.outerHTML);
	console.log('Final html', finalHtml);
	return { headContent, html: finalHtml ?? inlinedHtml ?? html, style };
};

export const parseHtmlToBlocks = (html) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(html, 'text/html');
	const blocks = [];

	const style = Array.from(doc.head.childNodes).find((n) => n.nodeName === 'STYLE');

	const parsedStyles = parseCssRules(style?.textContent ?? '');
	// console.log('parsed styles', parsedStyles);

	const applyClassStylesToChildren = (node) => {
		if (node.nodeType !== Node.ELEMENT_NODE || TAGS.includes(node.tagName.toUpperCase()))
			return;

		const nodeStyles = getClassAndInlineStyles(node, parsedStyles);
		node.setAttribute('style', styleToString(nodeStyles));

		Array.from(node.children).forEach(applyClassStylesToChildren);
	};

	const walk = (node) => {
		if (node.nodeType === Node.ELEMENT_NODE && TAGS.includes(node.tagName.toUpperCase())) {
			const id = node.getAttribute('data-id') ?? uuidv4();

			const { backgroundColor, ...styles } = getNearestBackgroundColour(node);

			const classStyles = getClassAndInlineStyles(node, parsedStyles);

			const nodeStyles = {
				...(styles ?? {}),
				...classStyles,
			};

			node.setAttribute('style', styleToString(nodeStyles));
			node.setAttribute('data-id', id);

			const href = getParentHref(node);

			Array.from(node.children).forEach(applyClassStylesToChildren);

			const { backgroundColor: classBGColour } = classStyles;
			blocks.push({
				id,
				tag: node.tagName.toLowerCase(),
				classes: node.getAttribute('class'),
				templateValue: node.getAttribute('template-value'),
				content: node.outerHTML,
				backgroundColour: backgroundColor ?? classBGColour,
				href,
			});
		} else {
			Array.from(node.childNodes).forEach(walk);
		}
	};

	walk(doc.body);

	const headContent = doc.head.outerHTML;
	return { headContent, blocks };
};

export const getClassAndInlineStyles = (node, headStyles) => {
	const classStyles = headStyles.reduce((acc, { selector, styles }) => {
		try {
			if (selector && !selector.startsWith('@') && node.matches(selector)) {
				acc = {
					...acc,
					...styles,
				};
			}
		} catch (e) {
			console.log('Error matching selector', e);
		}

		return acc;
	}, {});
	return {
		...classStyles,
		...parseStyleString(node.getAttribute('style')),
	};
};

const filterByVisible = (el) => {
	const style = el.getAttribute('style') ?? '';
	const className = el.getAttribute('class') ?? '';
	const classList = className.split(/\s+/);

	return (
		!style.includes('display:none') &&
		!style.includes('display: none') &&
		!classList.includes('show-on-mobile')
	);
};

export const parseTableHtml = (tableHtml, fullDocHtml) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(tableHtml, 'text/html');
	const table = doc.querySelector('table');
	if (!table) return { columns: [], rows: [] };

	const fullDoc = parser.parseFromString(fullDocHtml, 'text/html');
	const style = Array.from(fullDoc.head.childNodes).find((n) => n.nodeName === 'STYLE');

	const parsedStyles = parseCssRules(style?.textContent ?? '');

	const rows = Array.from(table.querySelectorAll('tr'))
		.filter(filterByVisible)
		.map((tr, rowIndex) => {
			const id = tr.getAttribute('data-id') ?? uuidv4();

			const rowStyle = getClassAndInlineStyles(tr, parsedStyles);

			const backgroundColour = rowStyle?.backgroundColour ?? rowStyle?.backgroundColor;
			const fontColour = rowStyle?.color ?? rowStyle?.colour;

			const row = { id, index: rowIndex, backgroundColour, fontColour };

			const cells = Array.from(tr.children).filter((el) => {
				if (el.tagName !== 'TD' && el.tagName !== 'TH') return false;
				return filterByVisible(el);
			});

			console.log('CELLS', cells);
			let colIndex = 0;

			cells.forEach((cell) => {
				const showOnMobileElements = cell.querySelectorAll('.show-on-mobile');
				showOnMobileElements.forEach((child) => child.remove());

				const span = parseInt(cell.getAttribute('colspan')) || 1;
				const cellId = cell.getAttribute('data-id');

				const cellStyle = getClassAndInlineStyles(cell, parsedStyles);

				console.log('CELL', { innerHTML: cell.innerHTML, outerHTML: cell.outerHTML });
				row[`col${colIndex}`] = cell.innerHTML.includes('<img')
					? cell.innerHTML
					: cell.textContent.trim(); //cell.innerHTML.trim();
				row[`col${colIndex}-outerHTML`] = cell.outerHTML;
				row[`col${colIndex}-colSpan`] = span;
				row[`col${colIndex}-cellId`] = cellId;

				if (cellStyle?.backgroundColor ?? cellStyle?.backgroundColour) {
					row.backgroundColour = cellStyle.backgroundColor ?? cellStyle.backgroundColour;
				}
				if (cellStyle?.color ?? cellStyle?.colour) {
					row.fontColour = cellStyle.color ?? cellStyle.colour;
				}
				for (let i = 1; i < span; i++) {
					row[`col${colIndex + i}`] = '';
					row[`col${colIndex + i}-spanCellId`] = cellId;
				}
				colIndex += span;
			});
			row.isHeader = cells.some((c) => c?.outerHTML?.includes('<th'));

			return row;
		});

	const colCount = rows.map((row) => {
		return Object.keys(row).filter((key) => /^col\d+$/.test(key)).length;
	});

	if (colCount.length === 0) {
		return { rows: [], columns: [] };
	}
	const maxColumns = Math.min(...colCount);

	console.log('PARSED TABLE ROWS', { colCount, rows, maxColumns });
	const columns = Array.from({ length: maxColumns }).map((_, i) => ({
		field: `col${i}`,
		headerName: `Column ${i + 1}`,
	}));

	return { columns, rows };
};

export const parseAttributes = (attributes, { attributes: attrs, styles }) => {
	// console.log('ATTR PARSE ATTRIBUTES', attributes, attrs, styles);
	const attrsMap = Array.from(attributes).reduce((acc, attr) => {
		acc[attr.name] = attr.value;
		return acc;
	}, {});
	const existingStyle = parseStyleString(attrsMap.style ?? '');
	// console.log('ATTR EXISTING STYLE OBJ', existingStyle);
	Object.entries(styles ?? {}).forEach(([k, v]) => {
		if (v) {
			existingStyle[k] = v;
		}
	});
	Object.entries(attrs ?? {}).forEach(([k, v]) => {
		if (v) {
			attrsMap[k] = v;
		}
	});
	const updatedStyleString = styleToString(existingStyle);
	attrsMap.style = updatedStyleString;

	// console.log('ATTR final obj', attrsMap);
	return Object.entries(attrsMap)
		.map(([key, value]) => `${key}="${value}"`)
		.join(' ');
};

export const generateTableHtml = (rows, columns, originalTableHtml) => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(originalTableHtml, 'text/html');
	const originalTable = doc.querySelector('table');

	const tableAttrs = Array.from(originalTable.attributes)
		.map((attr) => `${attr.name}="${attr.value}"`)
		.join(' ');

	const rowsHtml = rows
		.map((row) => {
			const backgroundColour = row.backgroundColour;
			const isHeader = row.isHeader;
			const tag = isHeader ? 'th' : 'td';
			const cellHtml = columns
				.map((col) => {
					const field = col.field;
					const value = row[field];

					const outerHTML = row[`${field}-outerHTML`];
					const colSpan = row[`${field}-colSpan`] ?? 1;
					const cellId = row[`${field}-cellId`];
					const spanCellId = row[`${field}-spanCellId`];

					if (spanCellId) return '';

					const originalCell = document.querySelector(`[data-id="${cellId}"]`);

					const newDiv = document.createElement('div');
					newDiv.innerHTML = value;
					const newImg = newDiv.getElementsByTagName('img')?.[0];

					if (originalCell) {
						const img = originalCell.getElementsByTagName('img')?.[0];

						let imgAttrs = ` src="${newImg?.src}" data-id="${
							img?.getAttribute('data-id') ?? uuidv4()
						}"`;
						if (img && newImg) {
							imgAttrs = Array.from(img.attributes)
								.map(
									(attr) =>
										`${attr.name}="${
											attr.name === 'src' ? newImg.src : attr.value
										}"`,
								)
								.join(' ');
						}
						const cellAttrs = parseAttributes(originalCell.attributes, {
							styles: {
								backgroundColor: backgroundColour,
								...((row.fontColour ?? backgroundColour) && {
									color: row.fontColour ?? getContrastingColor(backgroundColour),
								}),
							},
							attributes: { ...(colSpan > 1 && { colspan: colSpan }) },
						});

						const newContent = newImg ? `<img ${imgAttrs}  />` : value;

						return `<${tag} ${cellAttrs}>${newContent}</${tag}>`;
					} else if (outerHTML) {
						const temp = document.createElement('tr');
						temp.innerHTML = outerHTML;

						const td = temp.getElementsByTagName('td')?.[0];
						const th = temp.getElementsByTagName('th')?.[0];
						const img = temp.getElementsByTagName('img')?.[0];

						let imgAttrs = ` src="${newImg?.src}" data-id="${
							img?.getAttribute('data-id') ?? uuidv4()
						}"`;
						if (img && newImg) {
							imgAttrs = Array.from(img.attributes)
								.map(
									(attr) =>
										`${attr.name}="${
											attr.name === 'src' ? newImg.src : attr.value
										}"`,
								)
								.join(' ');
						}
						const outerAttrs = td?.attributes ?? th?.attributes;

						const cellAttrs = parseAttributes(outerAttrs, {
							styles: {
								backgroundColor: backgroundColour,
								...((row.fontColour ?? backgroundColour) && {
									color: row.fontColour ?? getContrastingColor(backgroundColour),
								}),
							},
							attributes: { ...(colSpan > 1 && { colspan: colSpan }) },
						});

						const newContent = newImg ? `<img ${imgAttrs}  />` : value;

						return `<${tag} ${cellAttrs}>${newContent}</${tag}>`;
					}

					return `<${tag}${colSpan > 1 ? ` colspan="${colSpan}"` : ''}${
						cellId ? ` data-id="${cellId}"` : ''
					}>${value ?? ''}</${tag}>`;
				})
				.filter(Boolean)
				.join('\n');

			const rowStyles = {
				backgroundColor: backgroundColour,
				...((row.fontColour ?? backgroundColour) && {
					color: row.fontColour ?? getContrastingColor(backgroundColour),
				}),
			};

			let newRow = `<tr data-id="${row.id ?? uuidv4()}"${
				row.backgroundColour ? ` ${styleToString(rowStyles)}` : ''
			}>${cellHtml}</tr>`;
			if (row.id) {
				const rowTarget = document.querySelector(`[data-id="${row.id}"]`);
				console.log('Row target', rowTarget);
				let rowAttrs = '';
				if (rowTarget) {
					rowAttrs = parseAttributes(rowTarget.attributes, {
						styles: {
							backgroundColor: row.backgroundColour,
						},
					});
					// const attrsMap = Array.from(rowTarget.attributes).reduce((acc, attr) => {
					// 	acc[attr.name] = attr.value;
					// 	return acc;
					// }, {});
					// const existingStyle = parseStyleString(attrsMap.style || '');
					// if (row.backgroundColour) {
					// 	existingStyle.backgroundColor = row.backgroundColour;
					// }
					// const updatedStyleString = styleToString(existingStyle);
					// attrsMap.style = updatedStyleString;

					// rowAttrs = Object.entries(attrsMap)
					// 	.map(([key, value]) => `${key}="${value}"`)
					// 	.join(' ');
					// rowAttrs = Array.from(rowTarget?.attributes)
					// 	.map((attr) => `${attr.name}="${attr.value}"`)
					// 	.join(' ');
					// const existingStyle = parseStyleString(rowTarget.getAttribute('style'));
					// existingStyle.backgroundColor = row.backgroundColour ?? 'transparent';

					// tr.setAttribute('style', styleToString(existingStyle));
					console.log('Row attrs', rowAttrs);
				}
				newRow = `<tr ${rowAttrs}>${cellHtml}</tr>`;
			}

			return newRow;
		})
		.join('\n');

	const fullTable = `<table ${tableAttrs}><tbody>${rowsHtml}</tbody></table>`;
	return fullTable;
};

export const makeTablesOutlookAndMobileSafe = (html) => {
	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = html;

	const tables = tempDiv.querySelectorAll('table');
	// <td class="hide-on-mobile" style="padding: 10px; width: 50%; font-size: 12px; text-align: left; word-wrap: break-word; word-break: break-word; min-width: 200px; max-width: 350px" data-id="5b7e7121-7f82-4c26-a838-555fb1191aa2">
	tables.forEach((table) => {
		const headerCells =
			Array.from(table.querySelectorAll('tr'))
				.find((tr) => tr.querySelector('th'))
				?.querySelectorAll('th') ?? [];

		const tableRows = Array.from(table.querySelectorAll('tr'));
		tableRows.forEach((row, rowIndex) => {
			const cells = row.querySelectorAll('td, th');

			// Only apply logic if > 2 columns and this is not the header
			if (cells.length >= 2 && !row.querySelector('th')) {
				const targetCell = cells[0];
				if (!targetCell.classList.contains('responsive-cell')) {
					targetCell.classList.add('responsive-cell');
				}
				// console.log('TARGET CELL', targetCell);
				const showHeader = Boolean(targetCell.innerHTML.trim());
				// Loop through remaining columns (skip col 0)
				for (let i = 1; i < cells.length; i++) {
					const header = headerCells[i]?.textContent?.trim() ?? '';
					const value = cells[i].innerHTML.trim();
					console.log('HEADER', { header, value });

					if (!cells[i].classList.contains('hide-on-mobile')) {
						cells[i].classList.add('hide-on-mobile');
					}
					if (header.length > 0 && value.length > 0) {
						const wrapperDiv = document.createElement('div');
						wrapperDiv.className = 'show-on-mobile';
						wrapperDiv.setAttribute('style', 'display: none; padding-top: 5px;');

						wrapperDiv.innerHTML = `${
							showHeader ? `<strong>${header}:</strong> ` : ''
						}${value}`;
						targetCell.appendChild(wrapperDiv);
					}
				}

				if (
					targetCell.classList.contains('hide-on-mobile') &&
					targetCell.querySelector('.show-on-mobile')
				) {
					targetCell.classList.remove('hide-on-mobile');
				}
			}
		});
		const rows = table.querySelectorAll('tr.responsive-row');

		rows.forEach((row) => {
			const cells = Array.from(row.children).filter(
				(el) => el.tagName === 'TD' || el.tagName === 'TH',
			);

			if (cells.length === 2) {
				cells.forEach((cell) => {
					const cellClone = cell.cloneNode(true);
					const isTh = cell.tagName === 'TH';
					const tag = isTh ? 'th' : 'td';

					// Create conditional HTML string
					const conditionalHtml = `
<!--[if mso]>
<${tag} width="50%" style="padding: 10px; min-width: 200px;">
<![endif]-->
<!--[if !mso]><!-- -->
<${tag} class="responsive-cell" style="padding: 10px; width: 50%; min-width: 200px;">
<!--<![endif]-->
${cellClone.innerHTML}
</${tag}>`;

					const template = document.createElement('template');
					template.innerHTML = conditionalHtml;

					const fragment = template.content;
					const nodes = Array.from(fragment.childNodes);

					nodes.forEach((node) => {
						row.insertBefore(node, cell);
					});

					row.removeChild(cell);
				});
			}
		});
	});
	return tempDiv.innerHTML;
};

export const applySignatureStyles = (element) => {
	if (element.nodeType !== Node.ELEMENT_NODE) return;

	const nonEmptyElements = Array.from(element.children).filter(
		(e) =>
			e.tagName?.toLowerCase() !== 'br' &&
			(e.textContent?.trim()?.length > 0 || e.children.length > 0),
	);

	const isNotEmpty =
		element.textContent?.trim()?.length > 0 ||
		element.children.length > 1 ||
		nonEmptyElements.length > 0;

	if (!isNotEmpty) return;

	const tag = (element.tagName ?? '').toLowerCase();
	const templateValue = 'user.signature';
	const match = FIELDS.find((f) => templateValue.endsWith(f.value));
	const type = templateValue.split('.')[0];
	const label = match?.label ?? templateValue;
	const fullLabel = match ? `${type[0].toUpperCase() + type.slice(1)}: ${label}` : templateValue;

	element.style.setProperty('--template-tooltip-label', `"${fullLabel}"`);
	element.style.setProperty('--data-signature', 'true');
	element.setAttribute('template-value', templateValue);
	if (BLOCK_ELEMENTS.includes(tag)) {
		element.setAttribute('data-signature', 'true');
	}
};
